import { css } from 'styled-components'
import theme from './theme'

const { breakpoints } = theme

/** Media Queries Mixin */
export const media = {
  xs: (...args) => css`
    @media (max-width: ${breakpoints.xs}px) {
      ${css(...args)}
    }
  `,
  sm: (...args) => css`
    @media (max-width: ${breakpoints.sm}px) {
      ${css(...args)}
    }
  `,
  md: (...args) => css`
    @media (max-width: ${breakpoints.md}px) {
      ${css(...args)}
    }
  `,
  lg: (...args) => css`
    @media (max-width: ${breakpoints.lg}px) {
      ${css(...args)}
    }
  `,
  xl: (...args) => css`
    @media (max-width: ${breakpoints.xl}px) {
      ${css(...args)}
    }
  `
}
